export default function HomeTabChangeName(way, name) {
    this.dataSet(way, name);
}